export default __webpack_public_path__ + "static/media/git.45ffb8cc.svg";